import { css } from "@stubhub/broadway-foundation/css";

/** Neutral background for the fallback abbreviation badge when no team brand color is available. */
export const DEFAULT_FALLBACK_BACKGROUND_COLOR = "#C4CED4";

export const favoriteTeamEventCardStyles = {
  root: css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    rowGap: "primitives.100",
    // Card width must equal the sibling GridCardBase column stride; the space right of the image is the visible gap between cards.
    width: "[184px]",
    tablet: {
      width: "[242px]",
    },
  }),
  imageContainer: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: "[172px]",
    height: "[97px]",
    tablet: {
      width: "[226px]",
      height: "[128px]",
    },
    overflowX: "hidden",
    overflowY: "hidden",
    borderStartStartRadius: "[12px]",
    borderStartEndRadius: "[12px]",
    borderEndStartRadius: "[12px]",
    borderEndEndRadius: "[12px]",
  }),
  logoImage: css({
    width: "[48px]",
    height: "[48px]",
    objectFit: "contain",
  }),
  teamImage: css({
    width: "full",
    height: "full",
    objectFit: "cover",
  }),
  fallbackAbbreviation: css({
    color: "text.onOverlay",
    fontSize: "primitives.400",
    fontWeight: "bold",
    letterSpacing: "[1px]",
  }),
  matchupText: css({
    display: "flex",
    flexDirection: "column",
    rowGap: "primitives.25",
  }),
  singleLine: css({
    lineClamp: 1,
  }),
  buyButton: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderStartStartRadius: "primitives.150",
    borderStartEndRadius: "primitives.150",
    borderEndStartRadius: "primitives.150",
    borderEndEndRadius: "primitives.150",
    backgroundColor: "bg.surface.stronger",
    paddingBlock: "primitives.100",
  }),
  cardLink: css({
    position: "absolute",
    insetBlockStart: "[0px]",
    insetInlineEnd: "[0px]",
    insetBlockEnd: "[0px]",
    insetInlineStart: "[0px]",
  }),
};
